//Search
export const ISO_REQUEST_SEARCH_START_LOADING = "ISO_REQUEST_SEARCH_START_LOADING";
export const ISO_REQUEST_SEARCH_END_LOADING = "ISO_REQUEST_SEARCH_END_LOADING";
export const ISO_REQUEST_SEARCH_LOADED = "ISO_REQUEST_SEARCH_LOADED";
export const SET_ISO_REQUEST_FILTER = "SET_ISO_REQUEST_FILTER";

//Notify Search
export const ISO_REQUEST_NOTIFY_START_LOADING = "ISO_REQUEST_NOTIFY_START_LOADING";
export const ISO_REQUEST_NOTIFY_END_LOADING = "ISO_REQUEST_NOTIFY_END_LOADING";
export const ISO_REQUEST_NOTIFY_LOADED = "ISO_REQUEST_NOTIFY_LOADED";
export const SET_ISO_REQUEST_NOTIFY_FILTER = "SET_ISO_REQUEST_NOTIFY_FILTER";

//Edit
export const ISO_REQUEST_START_LOADING = "ISO_REQUEST_START_LOADING";
export const ISO_REQUEST_END_LOADING = "ISO_REQUEST_END_LOADING";
export const ISO_REQUEST_LOADED = "ISO_REQUEST_LOADED";

//Invoice
export const ISO_REQUEST_INVOICE_START_LOADING = "ISO_REQUEST_INVOICE_START_LOADING";
export const ISO_REQUEST_INVOICE_END_LOADING = "ISO_REQUEST_INVOICE_END_LOADING";
export const ISO_REQUEST_INVOICE_LOADED = "ISO_REQUEST_INVOICE_LOADED";

//Items
export const ISO_REQUEST_ITEM_START_LOADING = "ISO_REQUEST_ITEM_START_LOADING";
export const ISO_REQUEST_ITEM_END_LOADING = "ISO_REQUEST_ITEM_END_LOADING";
export const ISO_REQUEST_ITEM_LOADED = "ISO_REQUEST_ITEM_LOADED";

//Related
export const ISO_REQUEST_RELATED_START_LOADING = "ISO_REQUEST_RELATED_START_LOADING";
export const ISO_REQUEST_RELATED_END_LOADING = "ISO_REQUEST_RELATED_END_LOADING";
export const ISO_REQUEST_RELATED_LOADED = "ISO_REQUEST_RELATED_LOADED";

//Certificate
export const ISO_REQUEST_CERTIFICATE_START_LOADING = "ISO_REQUEST_CERTIFICATE_START_LOADING";
export const ISO_REQUEST_CERTIFICATE_END_LOADING = "ISO_REQUEST_CERTIFICATE_END_LOADING";
export const ISO_REQUEST_CERTIFICATE_LOADED = "ISO_REQUEST_CERTIFICATE_LOADED";
